function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Pressable } from "react-native";
import { Icon } from "./Icon";
import { Text } from "./Text";
import { View } from "./View";
import { AccessibleInput } from "../hooks/useAccessibleInput";
import { useTheme } from "../styles";
/**
 * An UI element that allows the user to select from a given set of options.
 *
 * {@adf 💾̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̅̃̀̀̆̉̀̀̆̎̀̀̆̇̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̇̇̀̀̆̉̀̀̆̄̀̀̇̄̀̀̆̈̀̀̂̂̀̀̃̊̀̀̃́̀̀̃̀̀̀̃̀̀̀̂̌̀̀̂̂̀̀̆̌̀̀̆́̀̀̇̉̀̀̆̏̀̀̇̅̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̃̀̀̆̅̀̀̆̎̀̀̇̄̀̀̆̅̀̀̇̂̀̀̂̂̀̀̇̍̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̎̀̀̇̄̀̀̆̅̀̀̆̎̀̀̇̄̀̀̂̂̀̀̃̊̀̀̅̋̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̆̀̀̆̉̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̉̀̀̆̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆́̀̀̆̄̀̀̃̀̀̀̃̅̀̀̃̇̀̀̃̇̀̀̆́̀̀̃̆̀̀̂̍̀̀̆̂̀̀̃̈̀̀̆̅̀̀̃̂̀̀̂̍̀̀̃̄̀̀̆́̀̀̃̂̀̀̆̄̀̀̂̍̀̀̃̈̀̀̆̃̀̀̃̉̀̀̃̇̀̀̂̍̀̀̃́̀̀̆̃̀̀̆́̀̀̃̃̀̀̆̂̀̀̆́̀̀̃̈̀̀̃̃̀̀̆̂̀̀̃̄̀̀̃̀̀̀̆̃̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̆̌̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̉̀̀̆̍̀̀̆́̀̀̆̇̀̀̆̅̀̀̂̍̀̀̃̂̀̀̃̀̀̀̃̂̀̀̃̄̀̀̃̀̀̀̃̅̀̀̃̂̀̀̃̂̀̀̂̍̀̀̃́̀̀̃̂̀̀̃̀̀̀̃̅̀̀̃̄̀̀̃̈̀̀̂̎̀̀̇̀̀̀̆̎̀̀̆̇̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̌̀̀̆̌̀̀̆̅̀̀̆̃̀̀̇̄̀̀̆̉̀̀̆̏̀̀̆̎̀̀̂̂̀̀̃̊̀̀̂̂̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̈̀̀̆̅̀̀̆̉̀̀̆̇̀̀̆̈̀̀̇̄̀̀̂̂̀̀̃̊̀̀̃̇̀̀̃̅̀̀̂̌̀̀̂̂̀̀̇̇̀̀̆̉̀̀̆̄̀̀̇̄̀̀̆̈̀̀̂̂̀̀̃̊̀̀̃̄̀̀̃̂̀̀̃̄̀̀̇̍̀̀̇̍̀̀̅̍̀̀̇̍}
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-6}
 */ export function SegmentedControl(param) {
    var ariaLabel = param['aria-label'], value = param.value, onChangeValue = param.onChangeValue, items = param.items, testID = param.testID;
    var theme = useTheme().theme;
    var _useState = _sliced_to_array(useState({
        container: 0,
        items: []
    }), 2), widths = _useState[0], setWidths = _useState[1];
    var totalWidth = widths.items.reduce(function(carry, item) {
        if (carry === -1 || typeof item !== 'number') return -1;
        return carry + item;
    }, 0);
    var rows = widths.container > 0 && totalWidth > 0 ? Math.ceil(totalWidth / widths.container) : 1;
    var itemsPerRow = Math.floor(items.length / rows);
    return /*#__PURE__*/ _jsx(View, {
        testID: testID,
        onLayout: function(e) {
            if (e.nativeEvent.layout.width !== widths.container) {
                setWidths(_object_spread_props(_object_spread({}, widths), {
                    container: e.nativeEvent.layout.width
                }));
            }
        },
        row: true,
        style: {
            borderWidth: 1,
            borderColor: theme.color.gray600,
            borderRadius: 20,
            alignItems: 'stretch',
            flexWrap: 'wrap',
            overflow: 'hidden'
        },
        role: "combobox",
        "aria-label": ariaLabel,
        children: widths.container ? items.map(function(item, index) {
            var isSelected = value.includes(item.value);
            var currentRow = Math.floor(index / itemsPerRow);
            // const isFirstRow = currentRow === 0;
            var isLastRow = currentRow === rows - 1;
            // const isFirst = index === 0;
            var isLast = index % itemsPerRow === itemsPerRow - 1;
            return /*#__PURE__*/ _jsxs(Pressable, {
                role: "checkbox",
                "aria-selected": isSelected,
                testID: testID ? "".concat(testID, "_").concat(item.value) : undefined,
                onLayout: function(e) {
                    if (e.nativeEvent.layout.width !== widths.items[index]) {
                        var newItems = _to_consumable_array(widths.items);
                        newItems[index] = Math.min(e.nativeEvent.layout.width, widths.container / 2);
                        setWidths(_object_spread_props(_object_spread({}, widths), {
                            items: newItems
                        }));
                    }
                },
                onPress: function() {
                    if (isSelected) {
                        onChangeValue(value.filter(function(v) {
                            return item.value !== v;
                        }));
                    } else {
                        onChangeValue(_to_consumable_array(value).concat([
                            item.value
                        ]));
                    }
                },
                style: [
                    {
                        flexGrow: widths.container && widths.items.length === items.length ? 1 : undefined,
                        alignItems: 'center',
                        paddingHorizontal: 6,
                        paddingVertical: 10,
                        borderColor: 'transparent',
                        borderEndWidth: 1
                    },
                    rows > 1 ? {
                        flexGrow: 1,
                        flexBasis: "".concat(100 / rows, "%")
                    } : null,
                    isSelected ? {
                        backgroundColor: theme.color.primary100
                    } : null,
                    isLastRow ? null : {
                        borderBottomColor: theme.color.gray600,
                        borderBottomWidth: 1
                    },
                    isLast ? null : {
                        borderEndWidth: 1,
                        borderColor: theme.color.gray600
                    }
                ],
                children: [
                    item.icon ? /*#__PURE__*/ _jsx(Icon, {
                        name: item.icon,
                        color: isSelected ? 'white' : theme.color.gray500,
                        style: {
                            marginBottom: 4
                        }
                    }) : null,
                    /*#__PURE__*/ _jsx(Text, {
                        size: 13,
                        text: item.label,
                        color: isSelected ? 'white' : theme.color.gray500,
                        weight: "semibold"
                    })
                ]
            }, item.value);
        }) : null
    });
}
/**
 * Wraps <https://ouihealth.atlassian.net/browse/APPCORE-6> for use as a form
 * input.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-119}
 */ export function SegmentedControlInput(props) {
    return /*#__PURE__*/ _jsx(AccessibleInput, _object_spread_props(_object_spread({}, props), {
        children: function(_param) {
            var ref = _param.ref, accessibilityProps = _object_without_properties(_param, [
                "ref"
            ]);
            return /*#__PURE__*/ _jsx(SegmentedControl, _object_spread({}, props, accessibilityProps));
        }
    }));
}
